export default __webpack_public_path__ + "static/media/599DollarLimitNotice.d16ae422.jpg";